/**
 * @typedef {Object} ToothPartsDO
 * @property {string} toothGumType - The type of tooth gum (UPPER or LOWER)
 * @property {number} toothIndex - The index of the tooth
 * @property {string} toothPartsType - The type of tooth parts (ATTACH, BITESTOP, CUTOUT, HOOK, SLIT)
 * @property {string} fileUrl - The URL of the file
 * @property {string} fileType - The type of the file
 * @property {string} filePath - The path of the file
 */

/**
 * @type {ToothPartsDO[]}
 */ 

const toothPartsDOListSingle = [];

/**
 * @param {ToothPartsDO} toothPartsDO
 */

const addToothPartsDO = (toothPartsDO) => {
  toothPartsDOListSingle.push(toothPartsDO);
};

const getToothPartsDOList = () => {
  return toothPartsDOListSingle;
};

export default {
  addToothPartsDO,
  getToothPartsDOList,
};